import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { tiposClientesAPI } from '../services/api';
import { toast } from 'react-toastify';
import '../Clientes.css';

const TipoClienteForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    valor_abono: 0,
    descripcion: '',
    activo: true
  });

  const loadTipo = useCallback(async () => {
    try {
      const response = await tiposClientesAPI.getById(id);
      if (response.success) {
        setFormData(response.data);
      }
    } catch (error) {
      toast.error('Error al cargar tipo');
      navigate('/tipos-clientes');
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id) {
      loadTipo();
    }
  }, [id, loadTipo]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (type === 'number' ? parseFloat(value) || 0 : value)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let response;
      if (id) {
        response = await tiposClientesAPI.update(id, formData);
      } else {
        response = await tiposClientesAPI.create(formData);
      }

      if (response.success) {
        toast.success(id ? 'Tipo actualizado exitosamente' : 'Tipo creado exitosamente');
        navigate('/tipos-clientes');
      }
    } catch (error) {
      toast.error(error.message || 'Error al guardar tipo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cliente-form">
      <h1>{id ? 'Editar Tipo de Cliente' : 'Nuevo Tipo de Cliente'}</h1>
      
      <form onSubmit={handleSubmit} className="form-container">
        <div className="form-row">
          <div className="form-group">
            <label>Nombre *</label>
            <input
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Valor Abono *</label>
            <input
              type="number"
              name="valor_abono"
              value={formData.valor_abono}
              onChange={handleChange}
              step="0.01"
              min="0"
              required
            />
            <small style={{ color: '#7f8c8d', marginTop: '5px', display: 'block' }}>
              Este valor se usará por defecto en cargas masivas de débitos
            </small>
          </div>
        </div>

        <div className="form-group">
          <label>Descripción</label>
          <textarea
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            rows="3"
            style={{ padding: '10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '16px', width: '100%' }}
          />
        </div>

        <div className="form-group">
<label className="form-toggle-wrap">
              <span className="toggle-switch-box">
                <input
                  type="checkbox"
                  name="activo"
                  checked={formData.activo}
                  onChange={handleChange}
                />
                <span className="form-toggle-switch" />
              </span>
              <span className="form-toggle-label">{formData.activo ? 'Desactivar' : 'Activar'}</span>
            </label>
        </div>

        <div className="form-actions">
          <button type="button" onClick={() => navigate('/tipos-clientes')} className="btn-secondary">
            Cancelar
          </button>
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TipoClienteForm;

